import { SlbBannerCard } from "app/utils/interfaces/slb-banner-card.interface"

export const workflowsCardsDistribution: SlbBannerCard[] = [
  { titleRef: 'Section31A', contentRef: 'Section31D', imageRef: 'Section31B', subtitleRef: 'Section31C' },
  { titleRef: 'Section32A', contentRef: 'Section32D', imageRef: 'Section32B', subtitleRef: 'Section32C' },
  { titleRef: 'Section33A', contentRef: 'Section33D', imageRef: 'Section33B', subtitleRef: 'Section33C' },
  { titleRef: 'Section34A', contentRef: 'Section34D', imageRef: 'Section34B', subtitleRef: 'Section34C' },
  { titleRef: 'Section35A', contentRef: 'Section35D', imageRef: 'Section35B', subtitleRef: 'Section35C' },
  { titleRef: 'Section36A', contentRef: 'Section36D', imageRef: 'Section36B', subtitleRef: 'Section36C' },
];

export const workflowsVideosIdsComponents = ['kinetixCompletionDesign', 'kinetixFractureDesign'];

export const WorkflowPageLayout = {
    slots: ['SlbWorkflowsMainSlot', 'SlbWorkflowsContainerSlot', 'SlbBlueBottomBannerSlot'],
};


export const WorkflowDetailsPageTemplate = {
  slots: ['SlbSupportedWorkflowsFeatureSlot']
}